import { useState } from "react";
import { toast } from "sonner";
import { Logo } from "../components/Logo";
import { api, formatApiError } from "../lib/api";
import AdminDashboard from "./AdminDashboard";

export default function Admin() {
  const [token, setToken] = useState(() => localStorage.getItem("aiwc_token"));
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("aiwc_token", res.data.token);
      setToken(res.data.token);
      toast.success("Welcome back.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("aiwc_token");
    setToken(null);
  };

  if (token) return <AdminDashboard onLogout={logout} onUnauthorized={logout} />;

  const field = "w-full rounded-xl border border-stone-700 bg-stone-900 px-5 py-3.5 text-sm text-cream placeholder:text-stone-500 focus:outline-none focus:ring-2 focus:ring-ember/50 focus:border-ember transition-colors duration-300";

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-10"><Logo dark /></div>
        <form onSubmit={login} className="bg-stone-900/60 border border-stone-800 rounded-3xl p-8 space-y-4" data-testid="admin-login-form">
          <h1 className="font-serif text-2xl font-semibold text-cream">Admin sign in</h1>
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
                 data-testid="admin-email-input" className={field} />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
                 data-testid="admin-password-input" className={field} />
          <button type="submit" disabled={busy} data-testid="admin-login-button"
                  className="w-full rounded-full bg-ember text-cream text-sm font-semibold py-4 hover:bg-ember-dark transition-colors duration-300 disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <a href="/" data-testid="admin-back-home-link" className="mt-6 block text-center text-xs text-stone-500 hover:text-cream transition-colors duration-300">
          Back to the site
        </a>
      </div>
    </div>
  );
}
